import { AdTargeting, Features } from '@news-mono/web-common'
import { sectionThemeOverrider, colors } from '@news-mono/component-library'
import { layout } from '../../App.routing'
import { getCombinedCurationListingData } from './get-topic-segment'

type CommonwealthGamesSectionProps = {
    /** A unique identifier for the adSlots in this section. */
    adPos?: number
    /** Targeting info for the advertisement. */
    adTargeting?: AdTargeting
    /** If the aside advert should be shown. */
    showAsideAdvert?: boolean
    /** Conditional toggle for render of section */
    feature?: Features
    /** Conditional toggle for match widget enablement */
    widgetEnabled?: boolean
    /** Custom ID, usually used for logging purposes */
    debuggingCustomId?: string
}

export const commonwealthGamesSection = ({
    adPos,
    adTargeting,
    showAsideAdvert = true,
    feature,
    widgetEnabled = false,
    debuggingCustomId,
}: CommonwealthGamesSectionProps) => {
    const section = 'sport'
    const curation = 'commonwealth-games'

    return layout.nestedComposition({
        type: 'scheme-overrider',
        props: {
            override: sectionThemeOverrider('thenightly', section),
        },
        feature: feature,
        contentAreas: {
            children: [
                layout.nestedComposition({
                    type: 'section-content',
                    props: {
                        section: 'sport',
                        heading: 'Commonwealth Games',
                        onEvent: () => {},
                    },
                    contentAreas: {
                        children: [
                            layout.component({
                                type: 'section-header',
                                props: {
                                    heading: 'Commonwealth Games',
                                    headingUrl: '/sport/commonwealth-games',
                                    colorOverride: colors.commonwealthGamesGold,
                                    isCommonwealthGamesTheme: true,
                                },
                            }),
                            layout.nestedComposition({
                                type: 'luna',
                                props: { hasAfterAside: false },
                                contentAreas: {
                                    beforeAside: [
                                        layout.component({
                                            type: 'article-card-list',
                                            props: {
                                                dataDefinitionArgs:
                                                    getCombinedCurationListingData(
                                                        {
                                                            curation: {
                                                                id: curation,
                                                                itemCount: 3,
                                                            },
                                                            topic: section,
                                                            offset: 0,
                                                            pageSize: 3,
                                                        },
                                                    ),
                                                expectedItemCount: 3,
                                                adTargeting: adTargeting,
                                                debuggingCustomId,
                                            },
                                        }),
                                    ],
                                    aside: [
                                        layout.nestedComposition({
                                            type: 'box',
                                            props: {
                                                horizontalSpacing:
                                                    'outerMargin',
                                                horizontalSpacingBreakpoint:
                                                    'sm',
                                                flex: {
                                                    default: {
                                                        flexGrow: 1,
                                                        flexDirection: 'column',
                                                    },
                                                },
                                            },
                                            contentAreas: {
                                                main: [
                                                    ...(widgetEnabled
                                                        ? [
                                                            layout.component(
                                                                {
                                                                    type: 'commonwealth-games-medal-tally-widget',
                                                                    props: {
                                                                        maxRows: 10,
                                                                        refreshIntervalSeconds: 60,
                                                                        sortable:
                                                                            false,
                                                                        size: 'small',
                                                                        widgetState: 'results',
                                                                        includeTotal: true
                                                                    },
                                                                },
                                                            ),
                                                            layout.component({
                                                                type: 'general-horizontal-divider',
                                                                props: {
                                                                    verticalSpacing: 'outerMargin',
                                                                },
                                                            }),
                                                        ]
                                                        : []),
                                                    ...(showAsideAdvert
                                                        ? [
                                                              layout.component({
                                                                  type: 'ad-unit',
                                                                  props: {
                                                                      adType: 'inline',
                                                                      noticePosition:
                                                                          'above-center',
                                                                      slot: {
                                                                          id: `${adPos}-mrec-${section}`,
                                                                          size: 'above1280MrecHalfPage',
                                                                      },
                                                                      stickyOffset:
                                                                          'calc(var(--stickyHeaderHeight) + 80px)',
                                                                  },
                                                              }),
                                                          ]
                                                        : []),
                                                ],
                                            },
                                        }),
                                    ],
                                    afterAside: [],
                                },
                            }),
                        ],
                    },
                }),
            ],
        },
    })
}
